import React from 'react';
import classNames from 'classnames';
import useDeepCompareEffect from 'use-deep-compare-effect';

import { F } from '@/utils/intl';

import { TimeSlot, TimeslotList } from 'conversional-journey';

import styles from './index.less';
import TimeSlotSelectButton from './TimeSlotSelectButton';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

const TimeSlotHourList = ({
                            currentSlots,
                            selectedSlot,
                            onSelectSlot,
                            className,
                            date,
                            onlyShowStart,
                            hideDayIfNoSlots = false,
                            selectedExtra
                          }: {
  currentSlots: TimeslotList,
  selectedSlot: TimeSlot,
  date: Date,
  onSelectSlot: (slot) => void,
  className?: string,
  onlyShowStart?: boolean
  hideDayIfNoSlots?: boolean,
  /** Overlaid on the selected slot's button (see TimeSlotSelectButton `extra`). */
  selectedExtra?: React.ReactNode
}) => {
  const morningSlots = currentSlots.filter(slot => slot.start.hour() < 12)
  const afternoonSlots = currentSlots.filter(slot => slot.start.hour() >= 12 && slot.start.hour() < 17)
  const eveningSlots = currentSlots.filter(slot => slot.start.hour() >= 17)

  useDeepCompareEffect(() => {
    const matchingSlotsInTheDay = currentSlots.filter(slot => slot.start.isSame(moment(date), 'day'))
    if (!isEmpty(matchingSlotsInTheDay)){
      return onSelectSlot(matchingSlotsInTheDay.find(slot => slot.start.isSame(moment(date), 'hour')) || matchingSlotsInTheDay[0])
    }
    onSelectSlot(currentSlots[0])
  }, [currentSlots]);

  // Compare by timestamp — selectedSlot.start may be a dayjs object (edited
  // via an HourSelector) while list slots are moments.
  const isSelected = (slot) => slot.start.valueOf() === selectedSlot?.start?.valueOf?.()

  const renderSlot = (slot) => <TimeSlotSelectButton
    key={slot.start.toString()}
    className={isSelected(slot) ? styles.selectedSlotButton : ''}
    onlyShowStart={onlyShowStart}
    slot={slot}
    onClick={onSelectSlot}
    extra={isSelected(slot) ? selectedExtra : undefined}/>

  const morning = hideDayIfNoSlots && morningSlots.length === 0 ? null : <div>
    <F id={"common.morning"} defaultMessage={'Morning'}/>
    {morningSlots.map(renderSlot)}
  </div>

  const afternoon = hideDayIfNoSlots && afternoonSlots.length === 0 ? null : <div>
    <F id={"common.afternoon"} defaultMessage={'Afternoon'}/>
    {afternoonSlots.map(renderSlot)}
  </div>

  const evening = hideDayIfNoSlots && eveningSlots.length === 0 ? null : <div>
    <F id={"common.evening"} defaultMessage={'Evening'}/>
    {eveningSlots.map(renderSlot)}
  </div>

  return <div className={classNames(styles.timeSlotsListContainer, className)}>
    {morning}
    {afternoon}
    {evening}
  </div>
}

export default TimeSlotHourList
